export const DEFAULT_COVER =
  'https://s3-hk.2heng.xin/mstdn/static/alice-player/hand-drawn-vinyl-disc-logo-concept-vector.jpg'
